export default __webpack_public_path__ + "static/49a5c0ed758e033252d6d5c3f18a7218.jpeg";